
import { motion } from "framer-motion";

interface QuoteMessageProps {
  author: string;
  content: string;
}

export const QuoteMessage = ({ author, content }: QuoteMessageProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      className="max-w-md bg-[#0B93F6] text-white p-4 rounded-2xl rounded-br-none mb-4 ml-auto"
    >
      <p className="text-lg mb-2">{content}</p>
      <p className="text-sm text-white/90">— {author}</p>
    </motion.div>
  );
};
